import { render, staticRenderFns } from "./Body-Gui.vue?vue&type=template&id=9acde21c&scoped=true&lang=en&"
import script from "./Body-Gui.vue?vue&type=script&lang=js&"
export * from "./Body-Gui.vue?vue&type=script&lang=js&"
import style0 from "./Body-Gui.vue?vue&type=style&index=0&id=9acde21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9acde21c",
  null
  
)

export default component.exports